import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as fromRootStore from '../../../reducers';
import * as fromCommonStore from '../../../store';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';
import * as moment from 'moment';
// Observable class extensions
import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import swal from 'sweetalert2';
import { ServiceWalkInModel } from '../../../model/index';
import { CommonService, SalesReturnService, SubscribeService } from '../../../services/index';



@Component({
    selector: 'add-sales-return-tab',
    templateUrl: './addSalesReturn.component.html'
})
export class AddSalesReturnComponent implements OnInit {
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }


    statusCusCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    returnTypeCtrl: FormControl;
    returnToCtrl: FormControl;
    branchCtrl: FormControl;
    srclistCtrl: FormControl;
    filteredSrc: Observable<any[]>;
    srcList: any[] = [];
    paymentTypeList: string[] = ['CASH', 'CARD', 'CHEQUE', 'ONLINE'];
    potCusOptList: any[];
    statusList: any[];
    clientList: any[];
    returnTypeList: any[];
    returnToList : any[];
    branchList: any[];
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    salesBillentryDetails = [];
    columns = [];
    filteredItems: Observable<any[]>;
    filteredReference: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    @Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('editDeleteQtyTemplate') editDeleteQtyTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    minDate: any;
    subscribeAuth;


    constructor(
        public store: Store<fromRootStore.State>,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private salesReturnService: SalesReturnService, public subscribeService: SubscribeService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        //this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];

        //this.clientCtrl = new FormControl();

        //FOR AUTO COMPLETE VALIDATION --- HA MODEL
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.serialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        function hasValidReturnType(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "sales_return" && val != "spare_return" && val != "replacement" && val != "exchange" && val != "trial_return") {
                retVal = { inValidType: true };
            }
            return retVal;
        }

        function hasValidReturnTo(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "store" && val != "hv" && val != "soa") {
                retVal = { inValidType: true };
            }
            return retVal;
        }

        this.returnTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidReturnType.bind(this)
        ]);

        this.returnToCtrl = new FormControl('', [
            Validators.required,
            hasValidReturnTo.bind(this)
        ]);

        function hasValidSRC(input: FormControl) {
            let val = input.value, retVal = null;
            if (val && typeof val === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            hasValidSRC.bind(this)
        ]);
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.loadSrcList();

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());
            
        this.returnTypeList = [{
            value: 'sales_return',
            name: 'Sales Return'
        },{
            value: 'spare_return',
            name: 'Spare Return'
        }
        , {
            value: 'replacement',
            name: 'Replacement'
        }, {
            value: 'exchange',
            name: 'Exchange'
        }, {
            value: 'trial_return',
            name: 'Trial Return'
        }];

        this.returnToList = [{
            value: 'store',
            name: 'Store'
        }, {
            value: 'hv',
            name: 'HV'
        }, {
            value: 'soa',
            name: 'SOA'
        }];

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model', prop: 'name', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Amount', prop: 'amount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Qty', prop: 'quantity', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteQtyTemplate },
            { name: 'Free', prop: 'free_item', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellClass: 'cell-left' },
            { name: 'Action', prop: 'sno', width:60, minWidth:60, maxWidth: 60, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.serviceInData['date'] = new Date();


            this.searchComponent.clientSearchEmit.subscribe(($e) => {
                that.serviceInData['bill_id'] = $e['bill_id'];
                that.serviceInData['sale_no'] = $e['sale_no'];
                that.serviceInData['sale_date'] = $e['sale_date'];
                that.serviceInData['disp_sale_date'] = $e['disp_sale_date'];
                that.serviceInData['client_id'] = $e['client_id'];
                that.serviceInData['client_no'] = $e['client_no'];
                that.serviceInData['client_name'] = $e['client_name'];
                that.serviceInData['mobile'] = $e['mobile'];
                that.serviceInData['item'] = $e['item'];
                that.serviceInData['quantity'] = $e['quantity'];
                that.serviceInData['reference'] = $e['reference'];
                that.serviceInData['reference_by'] = $e['reference_by'];
                that.serviceInData['type'] = [];
                that.serviceInData['bill_amount'] = $e['tot_bill_amount'];
                that.serviceInData['bill_branch'] = $e['bill_branch'];
                that.serviceInData['from_type'] = $e['from_type']?$e['from_type']:'';

                //that.prodList = $e['prodRes'];
                // that.serviceInData['warranty'] = [];
                that.serviceInData['description'] = '';
                that.servicegriddata = [];
                //TO LOAD HA MODEL DETAILS
                that.serviceInData['sale_bill_id'] = $e['bill_id'];
                that.serviceInData['mode'] = 'Add';
                that.getHaModelDetails(that.serviceInData);
            });
        }
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
        }

        this.serviceInData['random_no'] = this.getRandomInt(1, 500);

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            // if (auth['islogin']) {
            //     if (auth['usertype'] == 'Super_Admin' || auth['usertype'] == 'Admin' || auth['usertype'] == 'Accounts') {
            //         this.showManageButton = true;
            //     }
            // }
        });

        //TO LOAD BRANCH COMBO
        this.subscribeAuth.add(this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        }));

    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
        if (!_.isEmpty(this.subscribeAuth)) {
            this.subscribeAuth.unsubscribe();
        }
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'Sales Return',
                date: moment(this.serviceInData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.serviceInData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit' || mode == 'View') {
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['auto_no'] = this._params['auto_no'];
                this.serviceInData['date'] = new Date(this._params['addedon']);

                const storedType = this._params['type'];
                if (storedType && storedType !== '') {
                    this.serviceInData['type'] = storedType.includes('&') ? storedType.split('&') : [storedType];
                } else {
                    this.serviceInData['type'] = [];
                }

                this.serviceInData['bank']       = this._params['bank'] || '';
                this.serviceInData['chqno']      = this._params['chqno'] || '';
                this.serviceInData['onlineno']   = this._params['onlineno'] || '';
                this.serviceInData['cash_amt']   = this._params['cash_amt'] || '';
                this.serviceInData['card_amt']   = this._params['card_amt'] || '';
                this.serviceInData['online_amt'] = this._params['online_amt'] || '';
                this.serviceInData['cheque_amt'] = this._params['cheque_amt'] || '';
                this.srclistCtrl.setValue(this.serviceInData['bank'] || '');

                this.returnTypeCtrl.setValue(this._params['return_type'] || '');
                this.returnToCtrl.setValue(this._params['return_to'] || '');

                this.getHaModelDetails(data);
            }
        }
    }

    getClientMobileNo(clientID): void {
        let that = this,
            params = {
                client_id: clientID
            };
        this.commonService
            .getClientMobileNo(params)
            .then(function (res: any) {
                console.log("resp",res.data);
            });
    }

    getHaModelDetails(data: any): void {
        let that = this,
            params = {
                bill_id: data.bill_id,
                mode: data.mode
            };
        this.getClientMobileNo(data.client_id);
        this.salesReturnService
            .getSalesReturnDetails(params)
            .then(function (res: any) {
                that.page.count = res.prodRes['length'];
                that.salesBillentryDetails = res.prodRes;

            });
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    displayReturnType(typeValue: string) {
        if (typeValue) {
            let fitem = _.find(this.returnTypeList, { 'value': typeValue });
            return fitem['name'];
        }
        return '';
    }

    displayReturnTo(typeValue: string) {
        if (typeValue) {
            let fitem = _.find(this.returnToList, { 'value': typeValue });
            return fitem['name'];
        }
        return '';
    }

    // displayFn(client_id: any) {
    //     if (this.clientList != undefined) {
    //         if (client_id && this.clientList.length > 0) {
    //             let fitem = _.find(this.clientList, { 'client_id': client_id });
    //             this.serviceInData['sale_no'] = fitem.sale_no;
    //             this.serviceInData['sale_date'] = fitem.sale_date;
    //             this.serviceInData['item'] = fitem.item;
    //             this.serviceInData['quantity'] = fitem.quantity;
    //             this.serviceInData['client_no'] = fitem.client_no;
    //             this.serviceInData['client_name'] = fitem.client_name;
    //             this.serviceInData['mobile'] = fitem.mobile; //ANOTHER FIELD
    //             this.serviceInData['reference_name'] = fitem.reference_name;
    //             this.serviceInData['bill_amount'] = fitem.bill_amount;
    //             //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
    //             return fitem['client_no'];
    //         }
    //     }
    //     return '';
    // }
    //  for loading the product and qunatity on change function
    /*   displayProd(model_id: any) {
           if (this.prodList != undefined) {
               if (model_id && this.prodList.length > 0) {
                   let fitem = _.find(this.prodList, { 'model_id': model_id });
                 
                   return fitem['name'];
               }
           }
           return '';
       }
       onChangeProd(ha: any) {
           let that = this;
           let model_id = ha.model_id;
           let fitem = _.find(this.prodList, { 'model_id': model_id });
          
           that.servicegriddata['prod_name'] = fitem['name'];
           that.servicegriddata['quantity'] = fitem['quantity'];
   
       }*/
    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.serviceInData = [];
            this.serviceInData['date'] = new Date();
        }
    }

    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayBranchFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                // this.serviceInData['bill_branch'] = fitem['branch_name'];
                return fitem['branch_name'];
            }
        }
        return '';
    }
    
    requiresPayment(returnType: string): boolean {
        return returnType === 'sales_return' || returnType === 'spare_return';
    }

    showBankField(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.includes('CHEQUE') || paymentTypes.includes('ONLINE') || paymentTypes.includes('CARD');
        }
        return paymentTypes === 'CHEQUE' || paymentTypes === 'ONLINE' || paymentTypes === 'CARD';
    }

    requiresChequeNo(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) { return paymentTypes.includes('CHEQUE'); }
        return paymentTypes === 'CHEQUE';
    }

    requiresTransactionNo(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) { return paymentTypes.includes('ONLINE'); }
        return paymentTypes === 'ONLINE';
    }

    requiresMultipleAmountFields(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) { return paymentTypes.length >= 2; }
        return false;
    }

    validateMultipleAmounts(): void {
        let total = 0;
        const types = this.serviceInData['type'];
        if (Array.isArray(types)) {
            if (types.includes('CASH')) { total += parseFloat(this.serviceInData['cash_amt']) || 0; }
            if (types.includes('CARD')) { total += parseFloat(this.serviceInData['card_amt']) || 0; }
            if (types.includes('ONLINE')) { total += parseFloat(this.serviceInData['online_amt']) || 0; }
            if (types.includes('CHEQUE')) { total += parseFloat(this.serviceInData['cheque_amt']) || 0; }
        }
        this.serviceInData['total_payment_amount'] = total;
    }

    loadSrcList(): void {
        this.commonService.getBankLedger({ name: '' }).then(res => {
            this.srcList = res['data'];
            if (this.serviceInData['bank']) {
                this.srclistCtrl.setValue(this.serviceInData['bank']);
            }
        });
    }

    filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(item =>
            (new RegExp(bank_name, 'gi').test(item.bank) || new RegExp(bank_name, 'gi').test(item.bank_name)));
    }

    displaySrc(item_id: number) {
        if (item_id && this.srcList.length > 0) {
            let fitem = _.find(this.srcList, { 'bank': item_id });
            if (fitem) {
                this.serviceInData['bank_name'] = fitem['bank_name'];
                return fitem['bank_name'];
            }
        }
        return '';
    }

    onDeleteSalesReturn(row: any): void {
        this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);
    }

    getReturnAmount() {
        let total = 0;
        this.salesBillentryDetails.forEach(det => total += det.free_item == 'No' ? (det.rate * det.quantity) : 0);

        return total;
    }

    onSaveSalesReturn() {
        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length,
            toast = {
                type: 'warning',
                title: 'WARNING'
            };

        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Sales Return');
            return;
        } else if (_.isEmpty(this.serviceInData['description'])) {
            toast['body'] = 'Please Type Description';
            this.toasterService.pop(toast);
            return;
        } else if(this.getReturnAmount() == 0) {
            swal('WARNING', 'Invalid Return Amount');
            return;
        }

        if (this.requiresPayment(this.serviceInData['return_type'])) {
            if (_.isEmpty(_.toString(this.serviceInData['type']))) {
                swal('WARNING', 'Please Select Payment Mode');
                return;
            }
            if (this.showBankField(this.serviceInData['type'])) {
                if (_.isEmpty(_.toString(this.serviceInData['bank']))) {
                    swal('WARNING', 'Please Select Bank');
                    return;
                }
            }
            if (this.requiresChequeNo(this.serviceInData['type'])) {
                if (_.isEmpty(_.toString(this.serviceInData['chqno']))) {
                    swal('WARNING', 'Please Enter Cheque No');
                    return;
                }
            }
            if (this.requiresTransactionNo(this.serviceInData['type'])) {
                if (_.isEmpty(_.toString(this.serviceInData['onlineno']))) {
                    swal('WARNING', 'Please Enter Online Transaction No');
                    return;
                }
            }

        }

        let testingDate = moment(this.serviceInData['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this.serviceInData['bill_id'],
                sale_bill_id: this.serviceInData['sale_bill_id'],
                sale_no: this.serviceInData['sale_no'],
                sale_date: this.serviceInData['sale_date'],
                auto_no: this.serviceInData['auto_no'],
                mobile: this.serviceInData['mobile'],
                date: testingDate,
                client_id: this.serviceInData['client_id'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                description: this.serviceInData['description'],
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                type: this.requiresPayment(this.serviceInData['return_type']) ? this.serviceInData['type'] : '',
                bank: this.serviceInData['bank'],
                chqno: this.serviceInData['chqno'],
                onlineno: this.serviceInData['onlineno'],
                cash_amount: this.serviceInData['cash_amt'],
                card_amount: this.serviceInData['card_amt'],
                online_amount: this.serviceInData['online_amt'],
                cheque_amount: this.serviceInData['cheque_amt'],
                // bill_amount: this.serviceInData['bill_amount'],
                bill_branch: this.serviceInData['branch_id'],
                return_type: this.serviceInData['return_type'],
                return_to: this.serviceInData['return_to'],
                from_type: this.serviceInData['from_type'],
                bill_amount: this.serviceInData['bill_amount']
            };

        this.isLoading = true;

        this.salesReturnService
            .addSaveSalesReturn(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subReloadServiceGrid();
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }

    onEditQuantity(event, row, editQty, actQty, ind){
        if(editQty > actQty){
            this.salesBillentryDetails[ind]['quantity'] = actQty;
            event.target.value = actQty;
            swal('ERROR', "Return quantity cannot be greater than Actual bill quantity", 'error');
        }else if(editQty == 0){
            this.onDeleteSalesReturn(row);
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/salesReturn/addSalesReturn.component.ts